/**
 * Declarative dataLayer tracking.
 *
 * Any element carrying `data-analytics-event` pushes that event name to the dataLayer when it, or
 * anything inside it, is clicked. An optional `data-analytics-payload` holding a JSON object is
 * merged into the push.
 *
 *   <a data-analytics-event="community_palette_empty_cta"
 *      data-analytics-payload='{"colour_code":"1006","cta":"sign_in"}'>…</a>
 *
 * Delegated from the document on purpose. Several of the tracked CTAs are rendered by React after
 * this module runs — the T212650 empty state's logged-in CTA is the existing add-to-collection
 * button, mounted into a wrapper that carries the attributes. Binding listeners at init time would
 * miss those; letting the click bubble to a single document-level listener catches them without
 * either bundle having to know about the other.
 */

const EVENT_ATTRIBUTE = "data-analytics-event";

export function readPayload(element) {
  const raw = element.getAttribute("data-analytics-payload");
  if (!raw) return {};

  try {
    const parsed = JSON.parse(raw);
    // A JSON array or scalar would spread into nonsense keys; only objects are meaningful here.
    return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
  } catch (error) {
    console.error("Could not parse data-analytics-payload", error, raw);
    return {};
  }
}

function onClick(event) {
  const target = event.target instanceof Element
    ? event.target.closest(`[${EVENT_ATTRIBUTE}]`)
    : null;

  if (!target) return;

  const name = target.getAttribute(EVENT_ATTRIBUTE);
  if (!name) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: name, ...readPayload(target) });
}

export default function initAnalyticsEvents() {
  document.addEventListener("click", onClick);
}
